module.exports = __webpack_public_path__ + "static/media/teachpadding.9e13350a.svg";